import React, { useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image } from 'primereact/image';
import DummyImage from "../../../assets/imgs/dummy-img.png"
import "../shared.css"

import moment from "moment";
import { baseURL } from "../../../Config";
import { toast } from "react-toastify";
import { handlePutRequest } from "../../../services/PutTemplate";

const ProfileDetail = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const userId = useSelector((state) => state.authenticationSlice?.userId);
    const loginData = useSelector((state) => state.authenticationSlice?.loginData);
    
    const history = useHistory();
    const dispatch = useDispatch();
    // Function to handle the deletion of a vehicle
    const handleDeleteTemplate = async (vehicleId) => {
        const payload = {
            userId: userId,
            // password:password,
        };

        try {
            const response = await dispatch(handlePutRequest(`api/user?userId=${[]}&password=${[]}`, payload, true, true));
            // if (response?.success) {
            toast.success("Vehicle deleted successfully");
            // handleUserVehicleList();
            // console.log(response.success, "response success")
            // setuserVehicleList(prevList => prevList.filter(vehicle => vehicle._id !== vehicleId));
            // }
        } catch (error) {
            toast.error("Error deleting vehicle");
        }
    };

    // const validationSchema = Yup.object().shape({
    //     // firstName: Yup.mixed().required("This field is required."),
    //     // lastName: Yup.mixed().required("This field is required."),
    //     // dateOfBirth: Yup.mixed().required("This field is required."),
    //     // mobile: Yup.mixed().required("This field is required."),
    //     // gender: Yup.mixed().required("This field is required."),
    // });

    // const formik = useFormik({
    //     validationSchema: validationSchema,
    //     initialValues: {
    //         // firstName: "",
    //         // lastName: "",
    //         // dateOfBirth: "",
    //         // corporateCode: "",
    //         // mobile: "",
    //         // gender: "",
    //     },

    //     onSubmit: async (data) => {
    //         let payload = {
    //             userId: userId,
    //             firstName: data?.firstName,
    //             lastName: data?.lastName,
    //             gender: data?.gender,
    //             dob: data?.dateOfBirth ? moment(data?.dateOfBirth).format("MM-DD-YYYY") : null,
    //         }
    //         console.log(payload)
    //         setSaveBtnLoading(true);

    //         try {

    //         }
    //         catch (error) {
    //             console.log(error)
    //         }
    //     },
    // });

    // const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    // const getFormErrorMessage = (name) => {
    //     return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    // };
    return (
        <>
            <div className="w-max-content ">
                <h4 className='font-semibold mb-6'>Profile Setting</h4>
                <div className='flex flex-column align-items-center justify-content-center lg:flex-row lg:align-items-stretch  p-3 border-200 border-3 border-round' style={{ gap: "3rem" }}>
                    {/* <div className='flex justify-content-center p-3 border-200 border-3 border-round' style={{ gap: "3rem" }}> */}

                    <div className=" flex flex-column align-items-center profile-img surface-card p-4">
                        <h4 className='text-white w-full mb-6'>Profile Picture</h4>
                        <Image src={`${baseURL}${loginData?.data?.profileImage}`} preview />
                        <h3 className="text-white mt-4">{loginData?.data?.firstName + " " + loginData?.data?.lastName}</h3>
                    </div>

                    <div className="profile-form">
                        <div className="w-full surface-card py-4 px-4 ">
                            <h4 className='text-white mb-6'>Personal Detail</h4>
                            <div className="grid">
                                <div className="col-12 xl:col-6 lg:col-6 md:col-12 p-fluid">

                                    <div className="text-lg mt-1 pt-3">
                                        <span className="text-white text-xl wdth_50">Email</span> : <span className="text-lg ">{loginData?.data?.email}</span>
                                    </div>
                                    <div className="text-lg mt-1 pt-3">
                                        <span className="text-white text-xl wdth_50">CNIC</span> : <span className="text-lg ">{loginData?.data?.cnic}</span>
                                    </div>
                                    <div className="text-lg mt-1 pt-3">
                                        <span className="text-white text-xl wdth_50">Gender</span> : <span className="text-lg ">{loginData?.data?.gender}</span>
                                    </div>
                                    <div className="text-lg mt-1 pt-3">
                                        <span className="text-white text-xl wdth_50">Mobile</span> : <span className="text-lg ">{loginData?.data?.mobile}</span>
                                    </div>
                                </div>
                                <div className="col-12 md:col-6 ml__5 p-fluid">
                                    <div className="text-lg mt-1 pt-3">
                                        <span className="text-white text-xl wdth_50">Type</span> : <span className="text-lg ">{loginData?.data?.userType === "1" ? ("Owner") : loginData?.data?.userType === "2" ? ("Passenger") : ("Both")}</span>
                                    </div>
                                    <div className="text-lg mt-1 pt-3">
                                        <span className="text-white  text-xl wdth_50">Date of birth</span> : <span className="text-lg ">{loginData?.data?.dob}</span>
                                    </div>

                                    {/* <div className="text-lg mt-1 pt-3">
                                        <span className="text-white  text-xl wdth_50">Invite code</span> : <span className="text-lg ">{"REC-2343"}</span>
                                
                                        <div className="flex flex-row ">
                                            <div className="flex"></div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="flex justify-content-center mt-2">
                                <Button label="Update" loading={saveBtnLoading} onClick={() => history.push('/passenger-profile')} type="submit" className="p-button p-button-primary block font-medium m-3 text-lg w-9rem" />
                                <Button label="Delete" loading={saveBtnLoading} type="submit" className="p-button p-button-danger block font-medium m-3 text-lg w-9rem" />
                            </div>
                        </div>
                    </div >
                </div>
            </div>
        </>
    )
}

export default ProfileDetail